/**
 * Loading reducer. `isLoading` controls whether the spinner should be shown.
 */

import { ActionTypes as types } from '../constants'

const initialState = {
  isLoading: false,
  showLoader: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ERROR.SHOW_ERROR_OVERPANEL:
    case types.TRANSACTION.RECEIVED_FUNDING_OPTIONS:
    case types.TRANSACTION.SHOW_UNILATERAL:
    case types.TRANSACTION.NO_FUNDING_SOURCE:
    case types.TRANSACTION.UNAVAILABLE_FI:
    case types.USER.UPGRADED_ACCOUNT:
    case types.CONTACTS.DELETED_CONTACT:
    case types.OVERPANELS.TOGGLE_OPEN_BANKING_OVERPANEL:
    case types.OVERPANELS.TOGGLE_CONFIRM_IDENTITY_OVERPANEL:
    case types.OVERPANELS.STOP_LOADING:
    case types.NOTE.REQUIRED_FIELD_ERROR:
      return {
        ...state,
        isLoading: false,
        showLoader: false,
      }

    case types.USER.UPGRADE_ACCOUNT:
    case types.TRANSACTION.PAY_REQUEST:
    case types.TRANSACTION.POST_TRAVEL_RULE_DATA:
    case types.TRANSACTION.REQUEST_MONEY:
    case types.TRANSACTION.SEND_MONEY:
    case types.TRANSACTION.SET_DUALCONTROL_CONTEXT:
    case types.ADDRESS.ADD_ADDRESS:
    case types.TRANSACTION.ADD_CARD:
    case types.TRANSACTION.FETCH_FUNDING_OPTIONS:
    case types.RECIPIENT.REQUEST_UNILATERAL_RECIPIENT_CHOICES:
    case types.CROSS_BORDER.REQUEST_RECIPIENT_DETAILS:
    case types.TRANSACTION.FETCH_SPECS:
    case types.TRANSACTION.REQUEST_CVV:
    case types.TRANSACTION.REQUEST_PURCHASE_CONSENT:
    case types.TRANSACTION.REQUEST_USER_AGREEMENT_CONSENT:
    case types.TRANSACTION.POST_PREFERRED_FUNDING_SOURCE:
    case types.CONTACTS.DELETE_CONTACT:
    case types.UNILATERAL.PORTABLE_ONBOARDING_IS_LOADING:
    case types.ROUTER.REDIRECT:
    case types.PPME.CREATE_PROFILE:
    case types.PPME.UPDATE_PROFILE:
    case types.TRANSACTION.RESOLVE_RTB_CONTINGENCY:
    case types.STORY.CHAT_UPDATE_CONTACT_BLOCK:
    case types.CONTACTS.UPDATE_CONTACT_BLOCK:
    case types.CONTACTS.LOADING_BLOCKED_CONTACTS:
    case types.UNILATERAL.CLAIM_PROCESS_LINKING:
      return {
        ...state,
        isLoading: true,
      }

    case types.TRANSACTION.PAID_REQUEST:
    case types.TRANSACTION.POSTED_TRAVEL_RULE_DATA:
    case types.ADDRESS.ADDED_SHIPPING_ADDRESS:
    case types.ADDRESS.ADDED_BILLING_ADDRESS:
    case types.TRANSACTION.ADDED_CARD:
    case types.AMOUNT.CHANGE_CURRENCY:
    case types.AMOUNT.CHANGE_REQUEST_CURRENCY:
    case types.TRANSACTION.SENT_MONEY:
    case types.RECIPIENT.RECEIVED_UNILATERAL_RECIPIENT_CHOICES:
    case types.CROSS_BORDER.RECEIVED_RECIPIENT_DETAILS:
    case types.TRANSACTION.RECEIVED_SPECS:
    case types.TRANSACTION.RESOLVE_CVV:
    case types.TRANSACTION.POSTED_PREFERRED_FUNDING_SOURCE:
    case types.EXTERNAL.RECEIVED_DATA:
    case types.UNILATERAL.PORTABLE_ONBOARDING_NOT_LOADING:
    case types.PPME.CREATED_PROFILE:
    case types.PPME.UPDATED_PROFILE:
    case types.TRANSACTION.RTB_ERROR:
    case types.TRANSACTION.RTB_INVALID_CREDENTIALS:
    case types.TRANSACTION.RESOLVED_RTB_CONTINGENCY:
    case types.STORY.CHAT_UPDATED_CONTACT_BLOCK:
    case types.STORY.RENDER_BLOCK_ALERT:
    case types.CONTACTS.UPDATED_CONTACT_BLOCK:
    case types.CONTACTS.RECEIVED_BLOCKED_CONTACTS:
    case types.UNILATERAL.CLAIM_SUCCESS:
    case types.UNILATERAL.CLAIM_ERROR:
      return {
        ...state,
        isLoading: false,
      }
    case types.TRANSACTION.REQUESTED_MONEY:
      return {
        ...state,
        // if we are going to redirect to partner site we will continue shoing the loading icon
        ...(!(action.data && action.data.willRedirectToPartner) && {
          isLoading: false,
        }),
      }

    case types.USER.CREATE_TEMP_ACCOUNT:
    case types.USER.CREATE_FULL_ACCOUNT:
    case types.TRANSACTION.GUEST_FETCH_FUNDING_OPTIONS:
    case types.EXTERNAL.RECEIVED_OPTIONS:
      return {
        ...state,
        showLoader: true,
      }

    case types.USER.CREATED_TEMP_ACCOUNT:
    case types.USER.CREATED_FULL_ACCOUNT:
    case types.TRANSACTION.HIT_SENDING_LIMIT:
      return {
        ...state,
        showLoader: false,
      }
    case types.USER.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.data.isLoading,
      }

    default:
      return state
  }
}
